export default __webpack_public_path__ + "static/Neoteric-ba42d968e0b692c6587d99837ddf225a.webp";